import withSuspense from 'app/routes/withSuspense'

import lazyWithRetry from 'core/system/lazyWithRetry'

const LazyBorrowerRoutes = lazyWithRetry(() => import('app/routes/BorrowerRoutes/BorrowerRoutes'))

const BorrowerRoutes = withSuspense(LazyBorrowerRoutes)

export default BorrowerRoutes
